import { MainGateway } from './main-gateway.interface';

const baseUrl = 'gk/main';
export class HttpMainGateway implements MainGateway {
  getLatestPlanDePrincipeData() {
    return { url: `${baseUrl}/plan-de-principe`, method: 'GET' };
  }

  getAllPlanDePrincipeData() {
    return { url: `${baseUrl}/all-plan-de-principe`, method: 'GET' };
  }

  saveNewPlanDePrincipeData(args: { data: any }) {
    return {
      url: `${baseUrl}/plan-de-principe`,
      method: 'POST',
      data: args.data,
    };
  }
  postErrorMessage(args: { data: any }) {
    return {
      url: `${baseUrl}/error`,
      method: 'POST',
      data: args.data,
    };
  }

  getCalculatorResponse(args: { data: any }) {
    return {
      url: `${baseUrl}/calculator-roi`,
      method: 'GET',
      params: args.data,
    };
  }

  getCitySuggestion(args: { data: any }) {
    return {
      url: `${baseUrl}/calculator-roi/find-city`,
      method: 'GET',
      params: args.data,
    };
  }
}
